/**
 * All Listings from gobnb.net/darak.com database
 * Auto-generated with property types and host data from WordPress
 * Total: 100 listings
 * With Firebase Storage photos: 98
 */

export interface Host {
  id: string;
  displayName: string;
  email?: string;
  joinedDate: string;
  responseRate: number;
  responseTime: string;
  isSuperhost: boolean;
}

export interface Listing {
  id: string;
  title: string;
  slug: string;
  description: string;
  propertyType: string;
  roomType: string;
  status: string;
  hostId: string;
  host: Host;
  location: {
    address: string;
    city: string;
    state: string;
    country: string;
    coordinates: { lat: number; lng: number };
  };
  capacity: {
    guests: number;
    bedrooms: number;
    beds: number;
    bathrooms: number;
  };
  pricing: {
    nightlyRate: number;
    weekendRate: number;
    cleaningFee: number;
    currency: string;
  };
  photos: { url: string }[];
  amenities: string[];
  instantBook: boolean;
  minNights: number;
  maxNights: number;
  checkInTime: string;
  checkOutTime: string;
  rating: { average: number; count: number };
  isFeatured: boolean;
}

export const ALL_LISTINGS: Listing[] = [
  {
    "id": "2310",
    "title": "Al Abou Guesthouse",
    "slug": "al-abou-guesthouse-2",
    "description": "<blockquote>\n<p style=\"text-align: left\">A cozy getaway in the heart of old Batroun, within a 1 min walk from the beaches and old souk</p>\n</blockquote>",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_2",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.256074248984916,
        "lng": 35.6578396819532
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 100,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2310/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2310/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2310/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2310/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2310/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 7,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_60",
      "displayName": "Stephan3919",
      "email": "stephan.moubarak@gmail.com",
      "joinedDate": "2024-01-29 07:45:56",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2914",
    "title": "Athena Guesthouse",
    "slug": "athena-guesthouse",
    "description": "Chabtine, 15 mins away from batroun\n\nEscape with your beloved ones to a private stayaction in the middle of nature with a spectacular view.\n\nPrivate stone house consits of 1 bedroom, 1 living room with 2 sofa beds, 1 bathroom, fully equipped kitchen\n\n&nbsp;",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_13",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2114249,
        "lng": 35.7506266
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2914/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2914/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2914/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2914/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2914/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "6:00 PM",
    "checkOutTime": "4:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_73",
      "displayName": "Revechamoun",
      "email": "revechamoun@hotmail.com",
      "joinedDate": "2024-03-01 09:07:23",
      "responseRate": 95,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3938",
    "title": "Bonjourein Maison d’Hôtes Unit2",
    "slug": "bonjourein-maison-dhotes-unit2",
    "description": "Immerse yourself in the charm of a meticulously restored old Lebanese house that perfectly marries heritage with modern luxury. Just a quick one-minute jaunt from the bustling Batroun, this guesthouse offers a serene retreat that transports you to a world of relaxation and exploration.\n\nNB: Sofa-bed available in Unit2",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_14",
    "location": {
      "address": "Kouba, Batroun District, North Governorate, 4104, Lebanon",
      "city": "Kouba",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2705179,
        "lng": 35.66696800100739
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 130,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3938/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3938/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3938/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3938/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "4:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_78",
      "displayName": "Bonjourein",
      "email": "bonjoureinmaisondhotes@gmail.com",
      "joinedDate": "2024-03-23 08:50:46",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4926",
    "title": "Hassoun (Double Bed)",
    "slug": "hassoun-double-bed",
    "description": "<div class=\"roomCategoryDetails\">\n<div>One Double Bed</div>\n<div></div>\n<div><span class=\"irbold\">Room facilities:</span>  A/C, Free WiFi, Daily housekeeping, Hair dryer, Complimentary toiletries, Bathroom, Shower, Coffee / Tea maker, Complimentary water in room, Espresso machine, Ironing board on request, Water kettle, Terrace, Desk, Seating area, Partial sea view, City view</div>\n<div></div>\n</div>",
    "propertyType": "bed-breakfast",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_12",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2548879,
        "lng": 35.6588567
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 112,
      "weekendRate": 134,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4926/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4926/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4926/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 2,
    "maxNights": 30,
    "checkInTime": "3:00 PM",
    "checkOutTime": "11:00 AM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_112",
      "displayName": "VillaParadiso",
      "email": "villaparadisobatroun@gmail.com",
      "joinedDate": "2024-10-01 07:33:22",
      "responseRate": 93,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1293",
    "title": "Night In Paradise",
    "slug": "night-in-paradise",
    "description": "Beautiful property in Lebanon. Perfect for your getaway.",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_3",
    "location": {
      "address": "Ehden, Zgharta District, North Governorate, Lebanon",
      "city": "Ehden",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.28271575257168,
        "lng": 35.98271369934083
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1293/cover.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 365,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": true,
    "host": {
      "id": "host_34",
      "displayName": "jeanmawad",
      "email": "jean-mawad@hotmail.com",
      "joinedDate": "2023-12-28 17:42:04",
      "responseRate": 94,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1616",
    "title": "Homesinn Cabin",
    "slug": "homesinn-cabin",
    "description": "Beautiful property in Lebanon. Perfect for your getaway.",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_7",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25663118062741,
        "lng": 35.66310167312623
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 70,
      "weekendRate": 80,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1616/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1616/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1616/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1616/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1616/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 7,
    "checkInTime": "4:00 PM",
    "checkOutTime": "2:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": true,
    "host": {
      "id": "host_14",
      "displayName": "nouryoussef",
      "email": "nour.youssef98@outlook.com",
      "joinedDate": "2023-12-20 14:39:06",
      "responseRate": 90,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2008",
    "title": "Sunset Guesthouse Batroun",
    "slug": "gracias-guesthouse-batroun",
    "description": "https://www.google.com/maps/place/Gracias+Guesthouse,+Batroun/@34.24738,35.6683262,18z/data=!4m6!3m5!1s0x151f590ab8a9c75f:0xcd2a7d8acef4297d!8m2!3d34.2472882!4d35.6682633!16s%2Fg%2F11fn6ckh50",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_13",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2548879,
        "lng": 35.6588567
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 75,
      "weekendRate": 90,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2008/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2008/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2008/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2008/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2008/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 90,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_52",
      "displayName": "Graciasguesthousebatroun",
      "email": "stg_7428@hotmail.com",
      "joinedDate": "2024-01-14 20:11:04",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2039",
    "title": "PACK AND GO- DREAM CATCHER",
    "slug": "pack-and-go-dream-catcher",
    "description": "A VAN CAMPING",
    "propertyType": "caravan",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_14",
    "location": {
      "address": "EHDEN",
      "city": "Ehden",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2906583,
        "lng": 35.9656763
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 70,
      "weekendRate": 70,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2039/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2039/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2039/photo-2.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_41",
      "displayName": "Zeinayoussef",
      "email": "zeina_youssef@hotmail.com",
      "joinedDate": "2024-01-05 14:23:06",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2210",
    "title": "Beachfront chalet-Kfaraabida, Batroun A24",
    "slug": "beachfront-chalet-kfaraabida-batroun-a24",
    "description": "Discover seaside serenity at our beachfront chalet, featuring a big bedroom, a fully-equipped kitchen, a private balcony with ocean views, modern amenities, and easy access to local attractions and water activities.",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_18",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.22670642013103,
        "lng": 35.65454006195069
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 50,
      "weekendRate": 60,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2210/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2210/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2210/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2210/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2210/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2276",
    "title": "Beachfront chalet-Kfaraabida, Batroun A26",
    "slug": "beachfront-chalet-kfaraabida-batroun-a26",
    "description": "Discover seaside serenity at our beachfront chalet, featuring a big bedroom, a fully-equipped kitchen, a private balcony with mountain views, modern amenities, and easy access to local attractions and water activities.",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_1",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.22659997046354,
        "lng": 35.654454231262214
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 50,
      "weekendRate": 60,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2276/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2276/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2276/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2276/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2276/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 94,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2730",
    "title": "RESIDENCE ETIENNE",
    "slug": "residence-etienne",
    "description": "CHALET AU BORD DE LA MEDITERANNEE AVEC UNE VUE SPLENDIDE",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_9",
    "location": {
      "address": "Chekka, Batroun District, North Governorate, Lebanon",
      "city": "Chekka",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.32805632476593,
        "lng": 35.72444915771485
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 60,
      "weekendRate": 150,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2730/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2730/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2730/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2730/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2730/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_65",
      "displayName": "etienne",
      "email": "etienne-homsi@hotmail.com",
      "joinedDate": "2024-02-06 10:26:21",
      "responseRate": 96,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3191",
    "title": "Sunflower, Modern Apartment Batroun",
    "slug": "modern-apartment-batroun",
    "description": "Apartment in Batroun, Modern design and beautiful neighborhood",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_4",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25125721491916,
        "lng": 35.660204887390144
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 2,
      "beds": 2,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 130,
      "weekendRate": 150,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3191/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3191/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3191/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3191/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3191/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3316",
    "title": "Villa for rent at aalali-batroun",
    "slug": "villa-for-rent-at-aalali-batroun-2",
    "description": "<p class=\"p1\"><span class=\"s1\">❗❗This breathtaking getaway can fit up to 10-12 sleeping guests❗</span></p>\n<p class=\"p1\"><span class=\"s1\">Amenties:</span></p>\n<p class=\"p1\"><span class=\"s1\">.5 bedrooms(double beds)</span></p>\n<p class=\"p1\"><span class=\"s1\">.4 bathrooms</span></p>\n<p class=\"p1\"><span class=\"s1\">.Living room</span></p>\n<p class=\"p1\"><span class=\"s1\">.fully equipped kitchen</span></p>\n<p class=\"p1\"><span class=\"s1\">.towels</span></p>\n<p class=\"p1\"><span class=\"s1\">.Private pool</sp",
    "propertyType": "villa",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_8",
    "location": {
      "address": "Aalali, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Aalali",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2044457,
        "lng": 35.7726793
      }
    },
    "capacity": {
      "guests": 12,
      "bedrooms": 5,
      "beds": 7,
      "bathrooms": 4
    },
    "pricing": {
      "nightlyRate": 400,
      "weekendRate": 450,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3316/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3316/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3316/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3316/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3316/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 15,
    "checkInTime": "6:00 PM",
    "checkOutTime": "3:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_85",
      "displayName": "Rodolphe",
      "email": "rodolphe-roukoz@hotmail.com",
      "joinedDate": "2024-04-09 21:33:21",
      "responseRate": 91,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3377",
    "title": "Private house in Batroun C",
    "slug": "private-house-in-batroun-c",
    "description": "Beautiful private house in Batroun city, close to all attractions",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_11",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.259983084418145,
        "lng": 35.661449432373054
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 150,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3377/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3377/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3377/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3377/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3377/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "3:00 PM",
    "checkOutTime": "1:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3398",
    "title": "Beautiful escape from Chabtine",
    "slug": "beautiful-escape-from-chabtine",
    "description": "Escape the noise of the city and enjoy tranquility of our beautiful village",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_12",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2114249,
        "lng": 35.7506266
      }
    },
    "capacity": {
      "guests": 5,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3398/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3398/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3398/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3398/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3398/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "5:00 PM",
    "checkOutTime": "2:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 93,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3424",
    "title": "MONKEY MANSION - SEVENOAKS TREEHOUSES",
    "slug": "monkey-mansion-sevenoaks-treehouses",
    "description": "Monkey Mansion - Part of SevenOaks Treehouse Hideaway - located in the woods of Ain el Tefeha, a small calm town 40 min from Beirut and 5 min from Bikfaya, with views ranging from Sannine mountains to the Mediterranean sea...\nThis secluded property is an urban retreat like no other. The treehouse provides an intimate, simple and restful retreat for two people :)",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_13",
    "location": {
      "address": "ST GERGES STREET",
      "city": "ST GERGES STREET",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.93388925092582,
        "lng": 35.7244056175413
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 125,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3424/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3424/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3424/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3424/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3424/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 365,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_87",
      "displayName": "ralphgemayel88",
      "email": "ralph.gemayel@gmail.com",
      "joinedDate": "2024-04-14 07:52:21",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "4571",
    "title": "Small Chalet in Batroun",
    "slug": "small-chalet-in-batroun",
    "description": "a cozy fully functional chalet in Batroun, next to Sawary resort.",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_5",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.24724868698545,
        "lng": 35.65986156463624
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 85,
      "weekendRate": 95,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4571/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4571/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4571/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4571/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4571/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4580",
    "title": "Ijdabra Nabil Bungalow",
    "slug": "ijdabra-nabil-bungalow",
    "description": "cozy bungalow with quite surrounding",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_6",
    "location": {
      "address": "Ijdabra, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Ijdabra",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.24430424837769,
        "lng": 35.687627792358406
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 100,
      "cleaningFee": 5,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4580/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4580/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4580/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4580/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4580/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 90,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4705",
    "title": "Chabtine Cabin B",
    "slug": "chabtine-cabin-b",
    "description": "Discover the ultimate retreat at our charming cabin in Chabtine, Lebanon! Nestled in a tranquil setting, this cozy cabin boasts a private pool and a spacious outdoor area, perfect for relaxation and recreation. Enjoy the serene surroundings and modern comforts that make this cabin an ideal getaway. Whether you want to take a refreshing dip in the pool, lounge under the stars, or explore the beautiful landscapes of Chabtine, our cabin offers an unforgettable escape. Book your stay today and indul",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_8",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2114249,
        "lng": 35.7506266
      }
    },
    "capacity": {
      "guests": 5,
      "bedrooms": 2,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 210,
      "weekendRate": 252,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4705/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4705/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4705/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4705/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4705/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 90,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4997",
    "title": "TheLittle One",
    "slug": "thelittle-one",
    "description": "1-bed rooftop chalet with kitchen, hot water, WiFi, smart TV, toiletries, towels. Fire pit, darts, babyfoot table, BBQ area, panoramic view lounge.\nHeating: AC + Chimney with 1 box of wood\nGreen surroundings.\nSleeps 2-4, option for 2 extra (extra charge).",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_13",
    "location": {
      "address": "Bqaatouta, Keserwan District, Keserwan-Jbeil Governorate, Lebanon",
      "city": "Bqaatouta",
      "state": "Mount Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.97463065,
        "lng": 35.78023138308774
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 100,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4997/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4997/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4997/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4997/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4997/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "5012",
    "title": "TheLittleTwo",
    "slug": "thelittletwo",
    "description": "2-bed rooftop chalet with kitchen, hot water, WiFi, smart TV, toiletries, towels. Fire pit, darts, babyfoot table, BBQ area, panoramic view lounge.\nHeating: AC + Chimney with 1 box of wood\nGreen surroundings.\nSleeps 5-6.\n\nBreakfast ($20 for 2) and shisha available upon request",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_14",
    "location": {
      "address": "Bqaatouta, Keserwan District, Keserwan-Jbeil Governorate, Lebanon",
      "city": "Bqaatouta",
      "state": "Mount Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.97463065,
        "lng": 35.78023138308774
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 2,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5012/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5012/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5012/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5012/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5012/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "5508",
    "title": "Mrah Chdid guesthouse",
    "slug": "mrah-chdid-guesthouse",
    "description": "<p data-start=\"80\" data-end=\"140\"><strong data-start=\"80\" data-end=\"138\">🌿 Cozy Guesthouse in Nature – 10 Minutes from Batroun</strong></p>\n<p data-start=\"142\" data-end=\"459\">Escape the noise and recharge in this charming guesthouse nestled in the heart of <strong data-start=\"224\" data-end=\"247\">Mrah Chdid, Batroun</strong>. Surrounded by greenery, it’s the perfect spot for couples, families, or friends looking for a calm and authentic stay while being just a short drive from Batroun’s vibrant ",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_19",
    "location": {
      "address": "Mrah Chdid, Mrah Shdid, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Mrah Chdid",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2258009,
        "lng": 35.6892483
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 150,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5508/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5508/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5508/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5508/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5508/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "6:00 PM",
    "checkOutTime": "4:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 96,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "835",
    "title": "Sabe3 Sama- Cabin- Batroun",
    "slug": "sabe3-sama-cabin-batroun",
    "description": "breathtaking view, calm area, amazing design, escape to this beautiful cabin",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_1",
    "location": {
      "address": "Mrah Ez Zaiat, Batroun District, North Governorate, 4201, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2171107,
        "lng": 35.7022126
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/835/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/835/photo-1.png"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/835/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/835/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/835/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 2,
    "maxNights": 30,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": true,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1273",
    "title": "Oliva guesthouse",
    "slug": "oliva-guesthouse",
    "description": "The Guesthouse is located in the charming neighborhood of Edde Al Batroun, which is in close proximity to the vibrant town of Batroun .\n\nThe area offers a unique blend of tranquility and convenience allowing guests to enjoy the peacefulness of nature while being just a short drive away ( 6 minutes) from the lively attractions of Batroun.",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_2",
    "location": {
      "address": "Eddeh, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Eddeh",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2347742,
        "lng": 35.6916404
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 70,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1273/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1273/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1273/photo-2.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 2,
    "maxNights": 7,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": true,
    "host": {
      "id": "host_31",
      "displayName": "Olivaguesthouse",
      "email": "jenifer.hanna75@gmail.com",
      "joinedDate": "2023-12-28 09:20:47",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1666",
    "title": "Gala guesthouse",
    "slug": "gala-guesthouse",
    "description": "<ul>\n \t<li>A guesthouse located in the heart of ebrine, 7 mins away from batroun !</li>\n</ul>\nour guesthouse welcomes you with a stunning panoramic view and a peaceful atmosphere with the most cist environment.\nGala house fits up to 6 persons, you can take one part of the house which fits 4 persons or the whole house that fits 8 persons!\n\nThe whole house:\n\n- 3 bedrooms / 2 sofa bed/ 2 salon / 2 toilets/ kitchen / 3 balconies/ terrace / wifi / 24/24 electricity !\n\nyou will enjoy every sunrise and",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_8",
    "location": {
      "address": "Ebrine",
      "city": "Ebrine",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.252762,
        "lng": 35.7057228
      }
    },
    "capacity": {
      "guests": 8,
      "bedrooms": 3,
      "beds": 2,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 150,
      "weekendRate": 150,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1666/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1666/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1666/photo-2.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 7,
    "checkInTime": "3:00 PM",
    "checkOutTime": "11:00 AM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_40",
      "displayName": "Stephany",
      "email": "stephanytedros@hotmail.com",
      "joinedDate": "2024-01-03 18:07:47",
      "responseRate": 93,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2002",
    "title": "BoHome Jbeil",
    "slug": "bohome-jbeil",
    "description": "Kick back and relax in this calm, stylish apartment. Located in a peaceful neighborhood in Blat, Byblos. Enjoy the quietness, the sea view, and sunsets from a cozy bohemian setting and comfortable furniture! It is only 6 mins from the center of Byblos and the beach and 3 minutes from LAU.",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_12",
    "location": {
      "address": "Jbeil, Jbeil District, Keserwan-Jbeil Governorate, 4504, Lebanon",
      "city": "Jbeil",
      "state": "Mount Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.120207346538194,
        "lng": 35.6653118133545
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 65,
      "weekendRate": 70,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2002/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2002/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2002/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2002/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2002/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 14,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:30 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_51",
      "displayName": "zoe",
      "email": "zoe.dagher39@gmail.com",
      "joinedDate": "2024-01-14 15:35:48",
      "responseRate": 93,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2256",
    "title": "BLISS GUEST HOUSE",
    "slug": "bliss-guest-house",
    "description": "A stylish, quaint yet modern guesthouse located within Anfeh’s most charming and traditional neighbourhoods",
    "propertyType": "bed-breakfast",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_19",
    "location": {
      "address": "Enfeh, Koura District, North Governorate, Lebanon",
      "city": "Anfeh",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.351182449999996,
        "lng": 35.738585703071934
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 100,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2256/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2256/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2256/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2256/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2256/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "14:00",
    "checkOutTime": "12:00",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_58",
      "displayName": "Simon",
      "email": "simon.azar@hotmail.fr",
      "joinedDate": "2024-01-25 14:55:35",
      "responseRate": 90,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2379",
    "title": "Midtown Apartment, Batroun",
    "slug": "midtown-apartment-batroun",
    "description": "Explore Batroun from our conveniently situated contemporary apartment, perfect for accommodating four guests, featuring a cozy living room, a well-equipped kitchen, a dining area, two inviting bedrooms, and a bathroom; relish in the breathtaking sea views that provide an ideal backdrop for your stay.",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_5",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25686173913364,
        "lng": 35.658144950866706
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 110,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2379/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2379/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2379/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2379/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2379/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2649",
    "title": "Beit Toula",
    "slug": "beit-toula",
    "description": "Welcome to Beit Toula .. 🏡\nIt’s a traditional Lebanese house located in the mountains of Batroun in a village called Toula , 15 min away from Batroun . Our guest house welcomes you in a peaceful and relaxing atmosphere with an amazing garden .\nOur guesthouse fits up to 8 persons\nPrivate pool 🏊‍♂️.\nHuge garden 🪴.\nPrivate parking.\nPergola.\nBarbecue 🍗.\n24/7 electricity.\nFree wifi .\nBonefire 🔥.\nMusic is allowed 24/24😉.\n\nNB: we also provide events with additional price.",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_8",
    "location": {
      "address": "Toula, Batroun District, North Governorate, 4204, Lebanon",
      "city": "Toula",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2018224,
        "lng": 35.7237488
      }
    },
    "capacity": {
      "guests": 8,
      "bedrooms": 3,
      "beds": 6,
      "bathrooms": 3
    },
    "pricing": {
      "nightlyRate": 240,
      "weekendRate": 280,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2649/cover.png"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2649/photo-1.png"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2649/photo-2.png"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2649/photo-3.png"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2649/photo-4.png"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "1:00 PM",
    "checkOutTime": "12:30 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 93,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3340",
    "title": "Villa for rent at aalali-batroun",
    "slug": "villa-for-rent-at-aalali-batroun",
    "description": "<p class=\"p1\"><span class=\"s1\">❗❗This breathtaking getaway can fit up to 8-10 sleeping guests❗</span></p>\n<p class=\"p1\"><span class=\"s1\">Amenties:</span></p>\n<p class=\"p1\"><span class=\"s1\">.4 bedrooms(double beds)</span></p>\n<p class=\"p1\"><span class=\"s1\">.4 bathrooms</span></p>\n<p class=\"p1\"><span class=\"s1\">.Living room</span></p>\n<p class=\"p1\"><span class=\"s1\">.fully equipped kitchen</span></p>\n<p class=\"p1\"><span class=\"s1\">.towels </span></p>\n<p class=\"p1\"><span class=\"s1\">.Private pool</sp",
    "propertyType": "villa",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_9",
    "location": {
      "address": "Aalali, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Aalali",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2044457,
        "lng": 35.7726793
      }
    },
    "capacity": {
      "guests": 10,
      "bedrooms": 4,
      "beds": 4,
      "bathrooms": 4
    },
    "pricing": {
      "nightlyRate": 350,
      "weekendRate": 400,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3340/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3340/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3340/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3340/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3340/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 15,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_85",
      "displayName": "Rodolphe",
      "email": "rodolphe-roukoz@hotmail.com",
      "joinedDate": "2024-04-09 21:33:21",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3557",
    "title": "Room Magie La Maison Bleue",
    "slug": "room-magie-la-maison-bleue",
    "description": "La Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Magie is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_1",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3557/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3557/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3557/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3557/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 93,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3578",
    "title": "Room Paradis La Maison Bleue",
    "slug": "room-paradis-la-maison-bleue",
    "description": "&nbsp;\n\nLa Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Paradis is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_4",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3578/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3578/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3578/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3578/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 96,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4717",
    "title": "Chabtine Cabin C",
    "slug": "chabtine-cabin-c",
    "description": "Discover the ultimate retreat at our charming cabin in Chabtine, Lebanon! Nestled in a tranquil setting, this cozy cabin boasts a private pool and a spacious outdoor area, perfect for relaxation and recreation. Enjoy the serene surroundings and modern comforts that make this cabin an ideal getaway. Whether you want to take a refreshing dip in the pool, lounge under the stars, or explore the beautiful landscapes of Chabtine, our cabin offers an unforgettable escape. Book your stay today and indul",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_9",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2114249,
        "lng": 35.7506266
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 105,
      "weekendRate": 126,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4717/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4717/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4717/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4717/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4717/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 93,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4913",
    "title": "Werwar (Twin Beds)",
    "slug": "werwar-twin-beds",
    "description": "<div class=\"roomCategoryDetails\">\n<div>Two beds and one free extra bed (Drawer Bed)</div>\n<div></div>\n<div><span class=\"irbold\">Room facilities:</span>  A/C, Free WiFi, Daily housekeeping, Hair dryer, Complimentary toiletries, Bathroom, Shower, Coffee / Tea maker, Complimentary water in room, Espresso machine, Ironing board on request, Water kettle, Terrace, Desk, Seating area, Partial sea view, City view</div>\n<div></div>\n<div><span class=\"irbold\">Bed types:</span>  Twin beds</div>\n</div>",
    "propertyType": "bed-breakfast",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_11",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25583308861139,
        "lng": 35.657329910792676
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 102,
      "weekendRate": 122,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4913/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4913/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4913/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4913/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 2,
    "maxNights": 30,
    "checkInTime": "3:00 PM",
    "checkOutTime": "11:00 AM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_112",
      "displayName": "VillaParadiso",
      "email": "villaparadisobatroun@gmail.com",
      "joinedDate": "2024-10-01 07:33:22",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "5033",
    "title": "TheEldest",
    "slug": "theeldest",
    "description": "3-bed apartment with kitchen, WiFi, smart TV, toiletries, towels, fire pit, BBQ, terrace with valley view.\nHeating: Heating machine ( fuel ) + Chimney with 1 box of wood.\nSleeps 10, option for 12-14.\n\nBreakfast ($20 for 2) and shisha available",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_15",
    "location": {
      "address": "Bqaatouta, Keserwan District, Keserwan-Jbeil Governorate, Lebanon",
      "city": "Bqaatouta",
      "state": "Mount Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.97463065,
        "lng": 35.78023138308774
      }
    },
    "capacity": {
      "guests": 10,
      "bedrooms": 3,
      "beds": 5,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 180,
      "weekendRate": 210,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5033/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5033/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5033/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5033/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5033/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "3:00 PM",
    "checkOutTime": "1:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "5051",
    "title": "TheSon",
    "slug": "theson",
    "description": "3-bed apartment with kitchen, WiFi, smart TV, toiletries, towels, indoor billiard, jacuzzi, terrace with valley view.\nAC &amp; Heating: Air conditioning in each room + Chimney with 1 box of wood.\nSleeps 10 to 12, option for 13-14.\n\nBreakfast ($20 for 2) and shisha available",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_16",
    "location": {
      "address": "Bqaatouta, Keserwan District, Keserwan-Jbeil Governorate, Lebanon",
      "city": "Bqaatouta",
      "state": "Mount Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.97463065,
        "lng": 35.78023138308774
      }
    },
    "capacity": {
      "guests": 12,
      "bedrooms": 3,
      "beds": 5,
      "bathrooms": 3
    },
    "pricing": {
      "nightlyRate": 210,
      "weekendRate": 240,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5051/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5051/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5051/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5051/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5051/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "4:00 PM",
    "checkOutTime": "2:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 95,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1845",
    "title": "Deir el kamar guesthouse",
    "slug": "deir-el-kamar-guesthouse",
    "description": "We welcome you to the guesthouse casa.dedeir, situated in Deir el Kamar, Chouf. This charming village showcases its captivating beauty through traditional stone houses adorned with vibrant red tile\n\n&nbsp;\n\n2 Bed Room\n\n1 Living Room\n\nKitchen\n\n2 Toilets with *rain shower*\n\n&nbsp;\n\nIncluding:\n\n&nbsp;\n\n- Electricity 24/24\n\n- Free Wifi\n\n- Bar\n\n- chimney\n\n&nbsp;\n\nOur fees are designed to suit various budgets and ensure a comfortable stay for our guests.\n\n&nbsp;\n\n_Check in 3pm | check out before 12 pm",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_9",
    "location": {
      "address": "Deir Al Qamar, Chouf District, Mount Lebanon Governorate, 1508, Lebanon",
      "city": "Deir El Qamar",
      "state": "Mount Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.69624429762842,
        "lng": 35.55420640833513
      }
    },
    "capacity": {
      "guests": 8,
      "bedrooms": 2,
      "beds": 6,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 85,
      "weekendRate": 95,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1845/cover.webp"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1845/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1845/photo-2.webp"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1845/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1845/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 29,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:30 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_43",
      "displayName": "Casadedeirdeirelkamar",
      "email": "eliedaher19921@hotmail.com",
      "joinedDate": "2024-01-05 18:17:35",
      "responseRate": 96,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2048",
    "title": "PACK AND GO- BEYOND PARADISE",
    "slug": "pack-and-go-beyond-paradise",
    "description": "VAN CAMPING",
    "propertyType": "caravan",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_15",
    "location": {
      "address": "EHDEN",
      "city": "Ehden",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2906583,
        "lng": 35.9656763
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2048/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2048/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2048/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2048/photo-3.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "2:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_41",
      "displayName": "Zeinayoussef",
      "email": "zeina_youssef@hotmail.com",
      "joinedDate": "2024-01-05 14:23:06",
      "responseRate": 93,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2384",
    "title": "Bahsa Cove Guesthouse",
    "slug": "bahsa-cove-guesthouse",
    "description": "Nestled just a short stroll from Bahsa Beach within the bustling heart of Batroun Souk, Bahsa Cove Guesthouse presents a delightful haven, combining comfort and convenience. With 2 bedrooms for peaceful nights, a fully equipped kitchen featuring a breakfast bar for leisurely mornings, and a well-appointed bathroom, this guesthouse provides a cozy retreat. The living room offers a warm and inviting atmosphere for guests to unwind. Ideal for those in search of a harmonious mix of beachside tranqui",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_6",
    "location": {
      "address": "Bahsa Beach, Batroun, Batroun District, North Governorate, Lebanon",
      "city": "Bahsa Beach",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25331645,
        "lng": 35.65726090613183
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 115,
      "weekendRate": 125,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2384/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2384/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2384/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2384/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3181",
    "title": "Big modern apartment Batroun",
    "slug": "big-modern-apartment-batroun",
    "description": "beautiful apartment in Batroun, with sea view and can accommodate 12 persons",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_3",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25217950405934,
        "lng": 35.66110610961915
      }
    },
    "capacity": {
      "guests": 14,
      "bedrooms": 5,
      "beds": 7,
      "bathrooms": 5
    },
    "pricing": {
      "nightlyRate": 300,
      "weekendRate": 350,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3181/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3181/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3181/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3181/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3181/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 93,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3359",
    "title": "Stay At Margz",
    "slug": "stay-at-margz",
    "description": "<ol>\n \t<li>Experience the ultimate seaside getaway at my stunning beach view apartment in Batroun! Situated within the Old Souk, walking distance from the marina, beach, restaurants, shopping, bars, historical sites, cafés, secure parking, secure apartment, 24/24 electricity and much more. Self-contained, 2 bedrooms, 2 bathrooms, the apartment sleeps 8. Ideal family or group getaway.</li>\n</ol>\nWith breathtaking views, the whole group will enjoy easy access to everything from this centrally loca",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_10",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.256732465722095,
        "lng": 35.659111426211894
      }
    },
    "capacity": {
      "guests": 8,
      "bedrooms": 2,
      "beds": 6,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 150,
      "weekendRate": 200,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3359/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 90,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_86",
      "displayName": "MargoAbi",
      "email": "margo.barsha@hotmail.com",
      "joinedDate": "2024-04-10 05:27:10",
      "responseRate": 94,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3462",
    "title": "Ground floor of a Villa Rawabi, Batroun",
    "slug": "ground-floor-of-a-villa-rawabi-batroun",
    "description": "Full ground floor of a Villa in Al Rawabe, Batroun for Rent\n- 4 min from highway and 5 min to the souk\n- Free private parking for 4 Cars",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_14",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25544290753698,
        "lng": 35.674663765629916
      }
    },
    "capacity": {
      "guests": 5,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 95,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3462/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3462/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3462/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3462/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3462/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3493",
    "title": "Chalet in Sawary 413 PB",
    "slug": "chalet-in-sawary-413-pb",
    "description": "beautiful view chalet in Sawary resort, Batroun\n\nall amenities available, in the center of the capital tourism city  Batroun\n\nbook soon",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_15",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.24707131408153,
        "lng": 35.65913200378419
      }
    },
    "capacity": {
      "guests": 5,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3493/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3493/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3493/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3493/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3493/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 7,
    "maxNights": 62,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 94,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3511",
    "title": "Cottage in Mtein",
    "slug": "cottage-in-mtein",
    "description": "amazing stone cottage in Mtein with access to pool and garden\n\nOne Pet is allowed.\nLoud Music and noises must stop at 12:30am.\nNo smoking inside the house\n\nNear by places and Activities:\nSki station 7mn ⛷🏂\nRPM Carting 3 mn away🚘🚗\nManege 3mn away\nNight life restaurants\nHiking🏃‍♀️🏃‍♂️\nWine Tasting 🍷",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_16",
    "location": {
      "address": "Mtein, Mtain, Matn District, Mount Lebanon Governorate, 4838, Lebanon",
      "city": "Mtein",
      "state": "Mount Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.893066,
        "lng": 35.7436538
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3511/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3511/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3511/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3511/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3511/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3552",
    "title": "Room Soleil La Maison Bleue",
    "slug": "room-soleil-la-maison-bleue",
    "description": "La Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Soleil  is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_0",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3552/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3552/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3552/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3552/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3562",
    "title": "Room Horizon La Maison Bleue",
    "slug": "room-horizon-la-maison-bleue",
    "description": "&nbsp;\n\nLa Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Horizon is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_2",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3562/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3562/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3562/photo-2.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "3:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 95,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3583",
    "title": "Room Serenite La Maison Bleue",
    "slug": "room-serenite-la-maison-bleue",
    "description": "&nbsp;\n\nLa Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Serenite  is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_5",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3583/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3583/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3583/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3583/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3588",
    "title": "Room Illusion La Maison Bleue",
    "slug": "room-illusion-la-maison-bleue",
    "description": "&nbsp;\n\nLa Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Illusion is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_6",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3588/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3588/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3588/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3588/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 90,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3609",
    "title": "Room Amour La Maison Bleue",
    "slug": "room-amour-la-maison-bleue",
    "description": "La Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Amour is a connected room with two bedrooms and  a seaview balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_10",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2307869,
        "lng": 35.66496624356534
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 2,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3609/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3609/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3609/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3609/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3609/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3726",
    "title": "KOALA HUT - SEVENOAKS TREEHOUSES",
    "slug": "koala-hut-sevenoaks-treehouses",
    "description": "Koala Hut - Part of SevenOaks Treehouse Hideaway - located in the woods of Ain el Tefeha, a small calm town 40 min from Beirut and 5 min from Bikfaya, with views ranging from Sannine mountains to the Mediterranean sea...\nThis secluded property is an urban retreat like no other. Whether you are a couple seeking an intimate escape, or a digital nomad urging an escape from the city to a peaceful place to work, or anyone looking for that nature shower, you are in the right place.",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_11",
    "location": {
      "address": "ST GERGES STREET",
      "city": "ST GERGES STREET",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.93380913716501,
        "lng": 35.72442680673207
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 125,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3726/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3726/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3726/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3726/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3726/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 31,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_87",
      "displayName": "ralphgemayel88",
      "email": "ralph.gemayel@gmail.com",
      "joinedDate": "2024-04-14 07:52:21",
      "responseRate": 91,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3831",
    "title": "Beit Sabah",
    "slug": "beit-sabah",
    "description": "Welcome to Beit Sabah, that comfortably accommodates up to 6 people. Experience a charming village lifestyle here, complete with the joys of gathering fresh eggs from our friendly hens ensuring your breakfast is as fresh and organic as it gets. In addition, you can engage in the delightful activity of making your own jams. Immerse yourself in this perfect setting within the coziness of Beit Sabah, where unforgettable memories are waiting to be made.",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_12",
    "location": {
      "address": "Chabtine",
      "city": "Chabtine",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2114249,
        "lng": 35.7506266
      }
    },
    "capacity": {
      "guests": 7,
      "bedrooms": 3,
      "beds": 5,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 110,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3831/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3831/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3831/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3831/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3831/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 365,
    "checkInTime": "5:00 PM",
    "checkOutTime": "3:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_92",
      "displayName": "valerianasr",
      "email": "nasrvaleria@gmail.com",
      "joinedDate": "2024-05-19 18:21:37",
      "responseRate": 91,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "4091",
    "title": "Fantasia",
    "slug": "fantasia",
    "description": "Enjoy the fantasy of the design while staying in this stylish apartment. Beautifully decorated and featuring a modern furniture, and a stunningly unique painting . Stay 7 min away from the heart of the city, yet in a calm and relaxing area away from the noise at one of El Helem - Dream luxury apartments. Fantasia is a special place that will make your stay memorable\n\n7 min form Batroun\n4 min from Biomass\n2 min from ixir winery\n1 min from St Hardini Monastery\n2 min from St Rafqa Monastery",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_15",
    "location": {
      "address": "Derya, Batroun District, North Governorate, 4201, Lebanon",
      "city": "Derya",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.21817227820358,
        "lng": 35.72630524635316
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 100,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4091/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4091/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4091/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4091/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4091/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 365,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_98",
      "displayName": "Elhelemdreamgetaway",
      "email": "tonyzakhour1992@gmail.com",
      "joinedDate": "2024-06-12 14:02:52",
      "responseRate": 91,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4208",
    "title": "Stay At Margz 1",
    "slug": "stay-at-margz-2",
    "description": "<ol>\n \t<li>Experience the ultimate seaside getaway at my stunning beach view apartment in Batroun! Situated within the Old Souk, walking distance from the marina, beach, restaurants, shopping, bars, historical sites, cafés, secure parking, secure apartment, 24/24 electricity and much more. Self-contained, 2 bedrooms, 2 bathrooms, the apartment sleeps 6. Ideal family or group getaway.</li>\n</ol>\nWith breathtaking views, the whole group will enjoy easy access to everything from this centrally loca",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_19",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.256732465722095,
        "lng": 35.659111426211894
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 2,
      "beds": 5,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 150,
      "cleaningFee": 40,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4208/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 90,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_86",
      "displayName": "MargoAbi",
      "email": "margo.barsha@hotmail.com",
      "joinedDate": "2024-04-10 05:27:10",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4309",
    "title": "Beachfront heaving",
    "slug": "beachfront-heaving",
    "description": "3 bedrooms apartment in batroun right next to the beach,with a 120 sqm terrace facing the sea",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_0",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.247355110548355,
        "lng": 35.66080570220948
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 3,
      "beds": 3,
      "bathrooms": 3
    },
    "pricing": {
      "nightlyRate": 240,
      "weekendRate": 240,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4309/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4309/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4309/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4309/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4309/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 3,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_100",
      "displayName": "Christelle",
      "email": "christellenajm1@gmail.com",
      "joinedDate": "2024-06-20 09:23:46",
      "responseRate": 96,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4370",
    "title": "Biatrice Guesthouse",
    "slug": "biatrice-guesthouse",
    "description": "Cozy guesthouse in Batroun city with modern touch",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_1",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25643609216709,
        "lng": 35.65950751304627
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 140,
      "weekendRate": 150,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4370/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4370/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4370/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4370/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4370/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4407",
    "title": "stand-alone house with pool-Kfaraabida",
    "slug": "stand-alone-house-with-pool-kfaraabida",
    "description": "<div class=\"flex-shrink-0 flex flex-col relative items-end\">\n<div>\n<div class=\"pt-0.5 juice:pt-0\">\n<div class=\"gizmo-bot-avatar flex h-6 w-6 items-center justify-center overflow-hidden rounded-full juice:h-8 juice:w-8\">\n<div class=\"relative p-1 rounded-sm flex items-center justify-center bg-token-main-surface-primary text-token-text-primary h-8 w-8\"></div>\n</div>\n</div>\n</div>\n</div>\n<div class=\"group/conversation-turn relative flex w-full min-w-0 flex-col agent-turn\">\n<div class=\"flex-col gap-1",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_2",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2366056511046,
        "lng": 35.65793009101975
      }
    },
    "capacity": {
      "guests": 12,
      "bedrooms": 6,
      "beds": 6,
      "bathrooms": 5
    },
    "pricing": {
      "nightlyRate": 500,
      "weekendRate": 550,
      "cleaningFee": 20,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4407/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4407/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4407/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4407/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4407/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "4412",
    "title": "Villa al jabal",
    "slug": "blue-pearls-2",
    "description": "Luxurious Villa with an indoor outdoor pool 📍kahlounieh, chouf\nCan fit up to 8 ppl sleeping 🛌\nWifi ✅\nBbq area ✅\nElectricity 24/7 ✅\nHot water ✅\nTV ✅\nDining area ✅\n-Pool size : 6x3 meters\n-Depth: 1.5 m\n\n&nbsp;",
    "propertyType": "villa",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_3",
    "location": {
      "address": "Kahlounieh",
      "city": "Kahlounieh",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.917348192501976,
        "lng": 35.63996317569564
      }
    },
    "capacity": {
      "guests": 8,
      "bedrooms": 2,
      "beds": 6,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 250,
      "weekendRate": 280,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4412/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4412/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4412/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4412/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4412/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "6:00 PM",
    "checkOutTime": "4:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_94",
      "displayName": "Maya",
      "email": "mayabhamdan@gmail.com",
      "joinedDate": "2024-06-02 13:11:55",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "5229",
    "title": "Sea View Lounge, A Luxury",
    "slug": "sea-view-lounge-a-luxury",
    "description": "A place to forget reality\nfun guest house rental.<!--more-->",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_17",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2548879,
        "lng": 35.6588567
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 2,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 130,
      "cleaningFee": 5,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5229/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5229/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5229/photo-2.png"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5229/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/5229/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_120",
      "displayName": "ALuxury",
      "email": "aluxuryhospitality@gmail.com",
      "joinedDate": "2025-02-15 20:39:46",
      "responseRate": 91,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "5280",
    "title": "Stay At Margz 2",
    "slug": "stay-at-margz-2-2",
    "description": "Batroun Old Souk\n\nSelf contained fully furnished apartment\n\nSleeps 4 guests\n\nAC in Lounge and Bedroom\n\n1 car park with apartment\n\nTop level, ocean views, large balcony\n\nBathroom + extra toilet",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_18",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25666471141097,
        "lng": 35.65901807276533
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 3,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 110,
      "weekendRate": 120,
      "cleaningFee": 25,
      "currency": "USD"
    },
    "photos": [],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 365,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_86",
      "displayName": "MargoAbi",
      "email": "margo.barsha@hotmail.com",
      "joinedDate": "2024-04-10 05:27:10",
      "responseRate": 96,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "767",
    "title": "Kouba, Batroun- Amazing appartment",
    "slug": "kouba-batroun-amazing-appartment",
    "description": "Check this beautiful place with 2 bedrooms, 2 bathrooms,\nsalon, dining room, kitchen.\n\nFully furnished.\n\nBalconies with an amazing view.\n\nSituated in Kouba, Batroun. 2 mins from Batroun Souks.",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_0",
    "location": {
      "address": "koubba road",
      "city": "Koubba",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.26884991071294,
        "lng": 35.66608428955079
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 50,
      "weekendRate": 70,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/767/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/767/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/767/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/767/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 2,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": true,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1408",
    "title": "Charming Apartment in Batroun",
    "slug": "charming-apartment-in-batroun",
    "description": "Beautiful property in Lebanon. Perfect for your getaway.",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_5",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25880233947452,
        "lng": 35.665460772256154
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 100,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1408/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1408/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1408/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1408/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1408/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 365,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": true,
    "host": {
      "id": "host_32",
      "displayName": "mayssaa",
      "email": "mayssaa.ali@outlook.com",
      "joinedDate": "2023-12-28 10:08:10",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1894",
    "title": "PACK AND GO- MOUNTAIN VIEW",
    "slug": "pack-and-go",
    "description": "a van camping",
    "propertyType": "caravan",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_11",
    "location": {
      "address": "Ehden, Zgharta District, North Governorate, Lebanon",
      "city": "Ehden",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2906583,
        "lng": 35.9656763
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 70,
      "weekendRate": 70,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1894/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1894/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1894/photo-2.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_41",
      "displayName": "Zeinayoussef",
      "email": "zeina_youssef@hotmail.com",
      "joinedDate": "2024-01-05 14:23:06",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "2053",
    "title": "PACK AND GO- UNDER SKY",
    "slug": "pack-and-go-under-sky",
    "description": "VAN CAMPING",
    "propertyType": "caravan",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_16",
    "location": {
      "address": "EHDEN",
      "city": "Ehden",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2906583,
        "lng": 35.9656763
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2053/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2053/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2053/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2053/photo-3.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_41",
      "displayName": "Zeinayoussef",
      "email": "zeina_youssef@hotmail.com",
      "joinedDate": "2024-01-05 14:23:06",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2874",
    "title": "Maria’s apartment",
    "slug": "marias-apartment",
    "description": "“ There’s no place like home , except the Beach “. Private access to the beach , best location in Kfarabida Batroun when the waves hit your feet , a stylish and rustic apartment on the beach including a Jacuzzi and a balcony with Sea View 360 degrees . Rent per day or per week . The apartment consists of 1 bedroom with a queen bed and a single bed + a “ divant lit “ , a bathroom , a living room and a kitchen .",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_11",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2307869,
        "lng": 35.66496624356534
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 90,
      "weekendRate": 110,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2874/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2874/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2874/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2874/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2874/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 14,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_72",
      "displayName": "Cynthia",
      "email": "tender_night@hotmail.com",
      "joinedDate": "2024-02-29 19:44:19",
      "responseRate": 94,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2945",
    "title": "Treehouse",
    "slug": "treehouse",
    "description": "Peaceful place between the trees to spend your night and days in Ain el deleb- Private treehouse",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_14",
    "location": {
      "address": "Ain Ed Delb, Sidon District, South Governorate, Lebanon",
      "city": "Ain Ed Delb",
      "state": "South",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.544055,
        "lng": 35.40619357814741
      }
    },
    "capacity": {
      "guests": 7,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 85,
      "weekendRate": 100,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2945/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2945/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2945/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2945/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2945/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 4,
    "maxNights": 4,
    "checkInTime": "2:00 PM",
    "checkOutTime": "9:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_75",
      "displayName": "Treehouse",
      "email": "maroun.sleiman1@hotmail.com",
      "joinedDate": "2024-03-07 10:10:11",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3001",
    "title": "La Casa Di Bella - Guest House",
    "slug": "la-casa-di-bella-guest-house",
    "description": "\"اكتشف جمال الحياة الريفية في منزلنا الرائع الواقع في قلب الطبيعة الخلابة.\nبيت حجري ساحر يتمتع بتصميم فريد وسحر طبيعي لا مثيل له. ستجد نفسك محاطًا بالمناظر الطبيعية الخلابة والهواء النقي، مما يوفر لك بيئة هادئة ومريحة للاسترخاء والاستمتاع بالهدوء والسكينة.\n.يتميز المنزل بتفاصيل فريدة من الحجر الطبيعي، وتصميم داخلي رائع يجمع بين الأصالة والراحة العصرية\nاستعد للابتعاد عن صخب المدينة والاستمتاع بالمزايا الرائعة للعيش في وسط الطبيعة الخلابة.\"",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_16",
    "location": {
      "address": "Akkar Governorate, Lebanon",
      "city": "Akkar Governorate",
      "state": "Akkar",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.51702396789498,
        "lng": 36.18638992309571
      }
    },
    "capacity": {
      "guests": 8,
      "bedrooms": 3,
      "beds": 6,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 96,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3001/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3001/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3001/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3001/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3001/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "1:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_80",
      "displayName": "Alaa_abbas19",
      "email": "mohamad.abbas@nrc.no",
      "joinedDate": "2024-03-23 10:14:46",
      "responseRate": 95,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3133",
    "title": "Chabtine Small bear",
    "slug": "chabtine-small-bear",
    "description": "amazing place perfect for honeymoon",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_1",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.208288626127285,
        "lng": 35.745820999145515
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 125,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3133/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3133/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3133/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3133/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3133/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3196",
    "title": "Zinnia, Private room 1 Batroun",
    "slug": "private-room-1-batroun",
    "description": "Private room in Batroun with all Amenities",
    "propertyType": "studio",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_5",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25239233857918,
        "lng": 35.66029071807862
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 50,
      "weekendRate": 60,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3196/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3196/photo-1.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3198",
    "title": "Daisy, Private room 2 Batroun",
    "slug": "private-room-2-batroun",
    "description": "Private room in Batroun with all Amenities",
    "propertyType": "studio",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_6",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2523568661966,
        "lng": 35.66011905670167
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 50,
      "weekendRate": 60,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3198/cover.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3531",
    "title": "Guesthouse in Mtein",
    "slug": "guesthouse-in-mtein",
    "description": "A three hundred years old renovated Traditional Lebanese House and Venue for all kind of events.\n\nThe Guesthouse is for up to 6 people\nOne Master bedroom (double bed)\nOne standard room :\n2 Single beds and one big sofa bed\n2 Bathrooms\nDining room\n2 Saloons\nFireplace\nExtra wood extra charge\nWood(10$ for 25kg)\nFully Equipped kitchen",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_17",
    "location": {
      "address": "Mtein, Mtain, Matn District, Mount Lebanon Governorate, 4838, Lebanon",
      "city": "Mtein",
      "state": "Mount Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.893066,
        "lng": 35.7436538
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 350,
      "weekendRate": 420,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3531/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3531/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3531/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3531/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3531/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3567",
    "title": "Room Fantaisie La Maison Bleue",
    "slug": "room-fantaisie-la-maison-bleue",
    "description": "La Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Fantaisie is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_3",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3567/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3567/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3567/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3567/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 96,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3598",
    "title": "Room Nuage La Maison Bleue",
    "slug": "room-nuage-la-maison-bleue",
    "description": "&nbsp;\n\nLa Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Nuage  is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_8",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3598/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3598/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3598/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3598/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3603",
    "title": "Room Melodie La Maison Bleue",
    "slug": "room-melodie-la-maison-bleue",
    "description": "&nbsp;\n\nLa Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Melodie is a Duplex room with a seaview balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_9",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 100,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3603/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3603/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3603/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3603/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4167",
    "title": "Elara",
    "slug": "elara",
    "description": "Stay in Elara and let it guide your dreams with its shining light for a relaxing and unforgettable stay\n\n7 min form Batroun\n4 min from Biomass\n2 min from ixir winery\n1 min from St Hardini Monastery\n2 min from St Rafqa Monastery",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_17",
    "location": {
      "address": "Derya, Batroun District, North Governorate, 4201, Lebanon",
      "city": "Derya",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.21821220083861,
        "lng": 35.726315975189216
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 100,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4167/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4167/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4167/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4167/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4167/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 365,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_98",
      "displayName": "Elhelemdreamgetaway",
      "email": "tonyzakhour1992@gmail.com",
      "joinedDate": "2024-06-12 14:02:52",
      "responseRate": 90,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4454",
    "title": "Bonjourein Villa",
    "slug": "bonjourein-villa",
    "description": "Welcome to our stunning villa in the charming coastal town of Kouba! Situated just a 2-minute drive away from the captivating Batroun old souks, our property offers the perfect blend of convenience, tranquility, and breathtaking mountain and sea views.\nWith accommodation for up to 10 people, our villa is perfect for large groups or families seeking a serene retreat.\nBook now and embark on a journey of relaxation, exploration, and cherished moments with your loved ones.",
    "propertyType": "villa",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_4",
    "location": {
      "address": "Koubba El Batroun",
      "city": "Koubba El Batroun",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 10,
      "bedrooms": 5,
      "beds": 7,
      "bathrooms": 3
    },
    "pricing": {
      "nightlyRate": 600,
      "weekendRate": 720,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4454/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4454/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4454/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4454/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4454/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 90,
    "checkInTime": "4:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_78",
      "displayName": "Bonjourein",
      "email": "bonjoureinmaisondhotes@gmail.com",
      "joinedDate": "2024-03-23 08:50:46",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "4802",
    "title": "Lebanese traditional stone house in Bejdarfel - Marleine",
    "slug": "lebanese-draditional-stone-house-in-bejdarfel-_-marleine",
    "description": "🏡✨ Discover the Charm of Bejdarfel! 🌿\n\nEscape to our enchanting 2-bedroom traditional stone Lebanese house in the picturesque village of Bejdarfel, nestled in the heart of Batroun district. 🌄\n\nThis beautiful retreat offers authentic charm with modern comforts, featuring cozy bedrooms, a serene outdoor seating area, and a refreshing pool to enjoy under the sun. 🌊☀️\n\nExperience the perfect blend of tradition and relaxation in a tranquil setting, ideal for a peaceful getaway or a memorable fami",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_10",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.24260139349694,
        "lng": 35.71681022644044
      }
    },
    "capacity": {
      "guests": 8,
      "bedrooms": 2,
      "beds": 4,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 150,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4802/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4802/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4802/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4802/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4802/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 91,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1312",
    "title": "NEO TANNOURINE",
    "slug": "neo-tannourine",
    "description": "Experience the modern lodge in TANNOURINE",
    "propertyType": "condo",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_4",
    "location": {
      "address": "Tannourie el tahta",
      "city": "Tannourine",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.206265617265565,
        "lng": 35.87689418435531
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 100,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1312/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1312/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1312/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1312/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "14:00",
    "checkOutTime": "12:00",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": true,
    "host": {
      "id": "host_33",
      "displayName": "Neo_Tannourine",
      "email": "gaelleabb@gmail.com",
      "joinedDate": "2023-12-28 11:32:16",
      "responseRate": 95,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1866",
    "title": "Jal dib",
    "slug": "jal-dib",
    "description": "Beautiful property in Lebanon. Perfect for your getaway.",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_10",
    "location": {
      "address": "Jal El Dib, Matn District, Mount Lebanon Governorate, Lebanon",
      "city": "Jal El Dib",
      "state": "Mount Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.9059132,
        "lng": 35.58421460546012
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 130,
      "weekendRate": 150,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1866/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1866/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1866/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1866/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1866/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 14,
    "maxNights": 90,
    "checkInTime": "10:00 AM",
    "checkOutTime": "7:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_47",
      "displayName": "Johnny",
      "email": "johnnysaab82@gmail.com",
      "joinedDate": "2024-01-08 15:10:02",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2267",
    "title": "Beachfront chalet-Kfaraabida, Batroun A23",
    "slug": "beachfront-chalet-kfaraabida-batroun-a23",
    "description": "Discover seaside serenity at our beachfront chalet, featuring a big bedroom, a fully-equipped kitchen, a private balcony with mountain views, modern amenities, and easy access to local attractions and water activities.",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_0",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.22656448721114,
        "lng": 35.654454231262214
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 50,
      "weekendRate": 60,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2267/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2267/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2267/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2267/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2267/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 90,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2331",
    "title": "ChezMansour",
    "slug": "chezmansour",
    "description": "Hey Hey &amp; Welcome to ChezMansour❤️\n\n-Our Wood Cabin is located 10 min away from Batroun\n-Our getaway consists of 1 Bedroom, 1 kitchenette, 1 indoor &amp; outdoor bathroom, indoor &amp; outdoor sitting area\n-Pool, Outdoor Fire-pit,Wifi, TV, sound-system, BBQ and Sajj Grill, Bar. We can organize your events from A to Z : Birthday- Proposal- Bachelor- Brunch- Gender Reveal Party or any other Gathering 🎈 🎉\nWe can provide catering services : Food Beverages and Music 🎵\n\nNB: Sleeping is for up t",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_4",
    "location": {
      "address": "Aabdelli, Batroun District, North Governorate, 4204, Lebanon",
      "city": "Aabdelli",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2067961,
        "lng": 35.7216443
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 180,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2331/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2331/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2331/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2331/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2331/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_61",
      "displayName": "ChezMansour",
      "email": "rachellemansour92@hotmail.com",
      "joinedDate": "2024-01-29 12:42:39",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2533",
    "title": "Valhalla. Chabtine",
    "slug": "valhalla-chabtine",
    "description": "The house accommodates up to 6 people which makes it perfect for small groups or families.\nA calming and relaxing guesthouse,\nsurrounded by valleys and mountain views, suitable for a tranquil retreat.\nEnjoy the indoor wood-burning fireplace, for a cozy atmosphere during your stay.\nAn indoor Jacuzzi that adds an element of relaxation and luxury.\nThe barbecue and the outdoor area with a fire pit that provide opportunities for outdoor gatherings, and enjoyment of the surrounding nature.",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_7",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2114249,
        "lng": 35.7506266
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 2,
      "beds": 5,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 140,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2533/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2533/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2533/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2533/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "1:00 PM",
    "checkOutTime": "11:00 AM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_62",
      "displayName": "jessy",
      "email": "jessy_bittar@hotmail.co.uk",
      "joinedDate": "2024-01-30 14:45:52",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2794",
    "title": "Chalet in Batroun",
    "slug": "chalet-in-batroun",
    "description": "A studio Chalet for rent in San Stephano resort Batroun, composed of one bedroom, a bathroom, a kitchenette, AC, TV, a balcony with a pool and sea view and a playground area for kids.\n\nWater and electricity 24/7 and access to pools and sand beach.",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_10",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2477808034542,
        "lng": 35.65878868103028
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 1,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 85,
      "weekendRate": 100,
      "cleaningFee": 30,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2794/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2794/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2794/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2794/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2794/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 2,
    "maxNights": 365,
    "checkInTime": "12:00 PM",
    "checkOutTime": "1:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_71",
      "displayName": "Michelekaram15",
      "email": "michelekk1975@gmail.com",
      "joinedDate": "2024-02-17 15:10:08",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2979",
    "title": "Bonjourein Maison d’Hôtes Unit1",
    "slug": "bonjourein-maison-dhotes",
    "description": "Immerse yourself in the charm of a meticulously restored old Lebanese house that perfectly marries heritage with modern luxury. Just a quick one-minute jaunt from the bustling Batroun, this guesthouse offers a serene retreat that transports you to a world of relaxation and exploration.",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_15",
    "location": {
      "address": "Kouba, Batroun District, North Governorate, 4104, Lebanon",
      "city": "Kouba",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2705179,
        "lng": 35.66696800100739
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 165,
      "weekendRate": 180,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2979/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2979/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2979/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2979/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2979/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "4:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_78",
      "displayName": "Bonjourein",
      "email": "bonjoureinmaisondhotes@gmail.com",
      "joinedDate": "2024-03-23 08:50:46",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3039",
    "title": "Modern Villa in Chabtine",
    "slug": "modern-villa-in-chabtine",
    "description": "ᴛʜɪꜱ ɪꜱ ᴀ ʟᴜxᴜʀɪᴏᴜꜱ 2 ꜰʟᴏᴏʀꜱ ᴜɴɪQᴜᴇ ᴠɪʟʟᴀ, ꜱɪᴛꜱ ɪɴ ᴛʜᴇ ᴇʟᴇᴠᴀᴛᴇᴅ ᴘᴏꜱɪᴛɪᴏɴ ɪɴ ᴄʜᴀʙᴛɪɴᴇ ᴠɪʟʟᴀɢᴇ ʟᴏᴄᴀᴛᴇᴅ ɪɴ ʙᴀᴛʀᴏᴜɴ ᴅɪꜱᴛʀɪᴄᴛ, ɴᴏʀᴛʜ ʟᴇʙᴀɴᴏɴ, 14 ᴋᴍ ᴀᴡᴀʏ ꜰʀᴏᴍ ʙᴀᴛʀᴏᴜɴ ꜱᴏᴜᴋꜱ / 20 ᴍɪɴᴜᴛᴇꜱ ᴅʀɪᴠɪɴɢ.",
    "propertyType": "villa",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_18",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2114249,
        "lng": 35.7506266
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 3,
      "beds": 5,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 400,
      "weekendRate": 450,
      "cleaningFee": 20,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3039/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3039/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3039/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3039/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3039/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 50,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3156",
    "title": "Chabtine Big bear",
    "slug": "chabtine-big-bear",
    "description": "beautiful place in the mountain, ideal for small groups or families",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_2",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.20821764418218,
        "lng": 35.74586391448975
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 135,
      "weekendRate": 150,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3156/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3156/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3156/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3156/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3156/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 96,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3201",
    "title": "Lilium, Private room 3 Batroun",
    "slug": "private-room-3-batroun",
    "description": "Private room in Batroun with all Amenities",
    "propertyType": "studio",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_7",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25239233857918,
        "lng": 35.660204887390144
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 70,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3201/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3201/photo-1.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3542",
    "title": "Room Reve La Maison Bleue",
    "slug": "room-reve-la-maison-bleue",
    "description": "La Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Reve is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_18",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2307869,
        "lng": 35.66496624356534
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3542/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3542/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3542/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3542/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3547",
    "title": "Room Etoile La Maison Bleue",
    "slug": "room-etoile-la-maison-bleue",
    "description": "La Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Etoile is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_19",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3547/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3547/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3547/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3547/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 94,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "3890",
    "title": "Blue Pearls",
    "slug": "blue-pearls",
    "description": "Blue Pearls private pool and chalet located at 📍Kahlounieh chouf (10 mins from baaklin)\n\n2 private chalets🏡 and 1 pool😍:\nFit up to 12✅\n2 bedrooms\n2 living (tv available)\nBathroom each\nKitchen\n\n-24/24 electricity ✅\n-Wifi available ✅\n-Amazing view✅\n-BBQ area ✅\n\nAs for our pricelist for 2 to 12 persons\n\n170$ weekdays\n200 $ weekends and holidays\ncheck-in : 4 p.m.\ncheck-out : 2 p.m\n\n(price includes both chalets and pool)",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_13",
    "location": {
      "address": "Kahlounieh, chouf",
      "city": "Kahlounieh",
      "state": "Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.97851686497358,
        "lng": 35.426392070009015
      }
    },
    "capacity": {
      "guests": 13,
      "bedrooms": 2,
      "beds": 6,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 170,
      "weekendRate": 200,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3890/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3890/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3890/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3890/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3890/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_94",
      "displayName": "Maya",
      "email": "mayabhamdan@gmail.com",
      "joinedDate": "2024-06-02 13:11:55",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4127",
    "title": "Celestia",
    "slug": "celestia",
    "description": "<blockquote>Stay in Celestia to evoke a sense of celestial dreams and heavenly realms.\nDive into your dreams in only few minutes from Batroun city</blockquote>\n7 min form Batroun\n4 min from Biomass\n2 min from ixir winery\n1 min from St Hardini Monastery\n2 min from St Rafqa Monastery",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_16",
    "location": {
      "address": "Derya, Batroun District, North Governorate, 4201, Lebanon",
      "city": "Derya",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.21812791969803,
        "lng": 35.72643399238587
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 100,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4127/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4127/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4127/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4127/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4127/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 365,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_98",
      "displayName": "Elhelemdreamgetaway",
      "email": "tonyzakhour1992@gmail.com",
      "joinedDate": "2024-06-12 14:02:52",
      "responseRate": 96,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "4692",
    "title": "Chabtine Cabin A",
    "slug": "chabtine-cabin-a",
    "description": "Discover the ultimate retreat at our charming cabin in Chabtine, Lebanon! Nestled in a tranquil setting, this cozy cabin boasts a private pool and a spacious outdoor area, perfect for relaxation and recreation. Enjoy the serene surroundings and modern comforts that make this cabin an ideal getaway. Whether you want to take a refreshing dip in the pool, lounge under the stars, or explore the beautiful landscapes of Chabtine, our cabin offers an unforgettable escape. Book your stay today and indul",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_7",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2114249,
        "lng": 35.7506266
      }
    },
    "capacity": {
      "guests": 2,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 155,
      "weekendRate": 186,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4692/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4692/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4692/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4692/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4692/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 92,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "1573",
    "title": "The Drom",
    "slug": "the-drom",
    "description": "Not your average BnB\n▪️ Single unit with a breathtaking view\n▪️ Self check-in, self check-out\n📍 Bchaaleh, Batroun.",
    "propertyType": "cabin",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_6",
    "location": {
      "address": "Bchaaleh, Batroun District, North Governorate, Lebanon",
      "city": "Bchaaleh",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2024437,
        "lng": 35.8234448
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 140,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1573/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1573/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1573/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1573/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/1573/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": true,
    "host": {
      "id": "host_39",
      "displayName": "TheDrom",
      "email": "info.thedromlb@gmail.com",
      "joinedDate": "2024-01-02 13:58:30",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "2149",
    "title": "Beachfront chalet-Kfaraabida, Batroun",
    "slug": "beautiful-beachfront-chalet-kfaraabida-batroun",
    "description": "An amazing chalet in the heart of Kfaraabida, with an unblockable   sea view  over the Mediterranean, with access to the pool.",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_17",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.226795128084504,
        "lng": 35.654432773590095
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 50,
      "weekendRate": 60,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2149/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2149/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2149/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2149/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2149/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "2322",
    "title": "Al Abou Guesthouse",
    "slug": "al-abou-guesthouse",
    "description": "<p style=\"text-align: left\">An old Lebanese house located in the heart of Batroun old neighbourhood</p>",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_3",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.256130572753115,
        "lng": 35.6577773205936
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 2,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 120,
      "weekendRate": 140,
      "cleaningFee": 5,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2322/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2322/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2322/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2322/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2322/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 7,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_60",
      "displayName": "Stephan3919",
      "email": "stephan.moubarak@gmail.com",
      "joinedDate": "2024-01-29 07:45:56",
      "responseRate": 91,
      "responseTime": "within a few hours",
      "isSuperhost": true
    }
  },
  {
    "id": "2896",
    "title": "Cynthia’s apartment",
    "slug": "cynthias-apartment",
    "description": "“ There’s no place like home , except the Beach.” An awesome and stylish rustic apartment on the Beach at Kfarabida Batroun where the Waves hit tour feet . Best location with private access to the beach . A beautiful place including a private terrace with Sea view 360 degrees and a Barbecue grill . It consists of one bedroom with a queen bed , a living room with Sea view and 2 leather sofa beds , one bathroom and a kitchen .",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_12",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2307869,
        "lng": 35.66496624356534
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 1,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 120,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2896/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2896/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2896/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2896/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/2896/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 14,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_72",
      "displayName": "Cynthia",
      "email": "tender_night@hotmail.com",
      "joinedDate": "2024-02-29 19:44:19",
      "responseRate": 91,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3011",
    "title": "Stand alone house in Kour",
    "slug": "stand-alone-house-in-kour",
    "description": "beautiful house in Kour, Batroun with amazing view and relaxing surrounding.",
    "propertyType": "house",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_17",
    "location": {
      "address": "Kour, Batroun District, North Governorate, 4201, Lebanon",
      "city": "Kour",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.2381032,
        "lng": 35.7365826
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 90,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3011/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3011/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3011/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3011/photo-3.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3011/photo-4.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 60,
    "checkInTime": "4:00 PM",
    "checkOutTime": "2:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 94,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3099",
    "title": "Chabtine Villa",
    "slug": "chabtine-villa",
    "description": "ᴛʜɪꜱ ɪꜱ ᴀ ʟᴜxᴜʀɪᴏᴜꜱ 2 ꜰʟᴏᴏʀꜱ ᴜɴɪQᴜᴇ ᴠɪʟʟᴀ, ꜱɪᴛꜱ ɪɴ ᴛʜᴇ ᴇʟᴇᴠᴀᴛᴇᴅ ᴘᴏꜱɪᴛɪᴏɴ ɪɴ ᴄʜᴀʙᴛɪɴᴇ ᴠɪʟʟᴀɢᴇ ʟᴏᴄᴀᴛᴇᴅ ɪɴ ʙᴀᴛʀᴏᴜɴ ᴅɪꜱᴛʀɪᴄᴛ, ɴᴏʀᴛʜ ʟᴇʙᴀɴᴏɴ, 14 ᴋᴍ ᴀᴡᴀʏ ꜰʀᴏᴍ ʙᴀᴛʀᴏᴜɴ ꜱᴏᴜᴋꜱ / 20 ᴍɪɴᴜᴛᴇꜱ ᴅʀɪᴠɪɴɢ.",
    "propertyType": "villa",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_19",
    "location": {
      "address": "Chabtine, Batroun District, North Governorate, 4231, Lebanon",
      "city": "Chabtine",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.21144726216298,
        "lng": 35.75071334838868
      }
    },
    "capacity": {
      "guests": 6,
      "bedrooms": 3,
      "beds": 5,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 385,
      "weekendRate": 420,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3099/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3099/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3099/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3099/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3099/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 50,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 99,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3113",
    "title": "Bahsa Bay Guesthouse",
    "slug": "bahsa-bay-guesthouse",
    "description": "Beautiful view apartment in Batroun, in the center of atractions",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_0",
    "location": {
      "address": "Batroun, Batroun District, North Governorate, 1400, Lebanon",
      "city": "Batroun",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.25251649180045,
        "lng": 35.65852582454682
      }
    },
    "capacity": {
      "guests": 4,
      "bedrooms": 2,
      "beds": 3,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 180,
      "weekendRate": 190,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3113/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3113/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3113/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3113/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3113/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 2,
    "maxNights": 20,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_9",
      "displayName": "GOBNB",
      "email": "gobnbnet@gmail.com",
      "joinedDate": "2023-12-19 08:58:50",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "3593",
    "title": "Room Secret La Maison Bleue",
    "slug": "room-secret-la-maison-bleue",
    "description": "&nbsp;\n\nLa Maison Bleue is a boutique Hotel located in Kfaraabida- Batroun that consists of 13 units with a common outdoor pool, a dining area and two rooftop areas\n\nRoom Secret  is one of the rooms with sea view balcony",
    "propertyType": "chalet",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_7",
    "location": {
      "address": "Kfaraabida, Batroun District, North Governorate, 4107, Lebanon",
      "city": "Kfaraabida",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 33.8892522,
        "lng": 35.4836827
      }
    },
    "capacity": {
      "guests": 3,
      "bedrooms": 1,
      "beds": 1,
      "bathrooms": 1
    },
    "pricing": {
      "nightlyRate": 80,
      "weekendRate": 80,
      "cleaningFee": 0,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3593/cover.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3593/photo-1.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3593/photo-2.jpg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/3593/photo-3.jpg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 30,
    "checkInTime": "2:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_89",
      "displayName": "Lamaisonbleue",
      "email": "ralphmansour360@hotmail.com",
      "joinedDate": "2024-04-27 09:46:42",
      "responseRate": 98,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  },
  {
    "id": "4193",
    "title": "Luna",
    "slug": "luna",
    "description": "Every dream need a shining moon in the darkness of the night, so we brought you “Luna”, on of the best getaways to spend your vacation. Within minutes of Batroun city\n\n7 min form Batroun\n4 min from Biomass\n2 min from ixir winery\n1 min from St Hardini Monastery\n2 min from St Rafqa Monastery",
    "propertyType": "apartment",
    "roomType": "entire_place",
    "status": "published",
    "hostId": "host_18",
    "location": {
      "address": "Derya, Batroun District, North Governorate, 4201, Lebanon",
      "city": "Derya",
      "state": "North Lebanon",
      "country": "Lebanon",
      "coordinates": {
        "lat": 34.21818114990187,
        "lng": 35.72643399238587
      }
    },
    "capacity": {
      "guests": 7,
      "bedrooms": 2,
      "beds": 4,
      "bathrooms": 2
    },
    "pricing": {
      "nightlyRate": 100,
      "weekendRate": 120,
      "cleaningFee": 10,
      "currency": "USD"
    },
    "photos": [
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4193/cover.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4193/photo-1.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4193/photo-2.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4193/photo-3.jpeg"
      },
      {
        "url": "https://storage.googleapis.com/lebanest-e1a43.firebasestorage.app/listings/4193/photo-4.jpeg"
      }
    ],
    "amenities": [
      "wifi",
      "kitchen",
      "parking"
    ],
    "instantBook": true,
    "minNights": 1,
    "maxNights": 365,
    "checkInTime": "3:00 PM",
    "checkOutTime": "12:00 PM",
    "rating": {
      "average": 0,
      "count": 0
    },
    "isFeatured": false,
    "host": {
      "id": "host_98",
      "displayName": "Elhelemdreamgetaway",
      "email": "tonyzakhour1992@gmail.com",
      "joinedDate": "2024-06-12 14:02:52",
      "responseRate": 97,
      "responseTime": "within a few hours",
      "isSuperhost": false
    }
  }
];

export default ALL_LISTINGS;
